const E = {
  'Back to Invoices': 'Back to Invoices',
  'Print Invoice Confirmation': 'Print Invoice Confirmation',
  'Thank you for your payment': 'Thank you for your payment',
  informationText: 'A summary of your transaction can be found below. Please note it may take up to 3 days for the Balance Due field to be updated.',
  'Maxxam Confirmation': 'Bureau Veritas Confirmation:',
  'Confirmed On': 'Confirmed On:',
  'Paid By': 'Paid By:',
  errorMessage: 'Something went wrong! Please contact Bureau Veritas Technical Department.',
  errorMessage2: 'You have not paid invoice recently. Please try again or contact Bureau Veritas Technical Department.',
  PaymentConfirmation: 'Payment Confirmation',

  'Invoice #': 'Invoice #',
  'PO #': 'PO #',
  'Invoice Amount': 'Invoice Amount',
  'Balance Due': 'Balance Due',
  'Project #': 'Project #',
  'Payment Amount': 'Payment Amount',
  'Company Name': 'Company Name',
  'Prepaid Request#': 'Prepaid Request #',
  'Submission#': 'Submission #',
};

const F = {
  'Back to Invoices': 'Revenir aux factures',
  'Print Invoice Confirmation': 'Imprimer la confirmation de facture',
  'Thank you for your payment': 'Merci pour votre paiement',
  informationText: 'Vous trouverez ci-dessous un résumé de votre transaction. Veuillez noter que le montant indiqué dans le champ Solde dû sera ajusté dans les trois prochains jours.',
  'Maxxam Confirmation': 'Confirmation des Laboratoires Bureau Veritas:',
  'Confirmed On': 'Confirmé le:',
  'Paid By': 'Mode de paiement:',
  errorMessage: 'Il y a eu un problème ! Veuillez contacter le service technique des Laboratoires Bureau Veritas.',
  errorMessage2: 'Le paiement ne s’est pas effectué correctement. Essayez de nouveau ou contactez le service technique des Laboratoires Bureau Veritas.',
  PaymentConfirmation: 'Confirmation de paiement',

  'Invoice #': 'No de facture',
  'PO #': 'No de PO',
  'Balance Due': 'Solde dû',
  'Project #': 'No de projet',
  'Invoice Amount': 'Montant de la facture',
  'Payment Amount': 'Montant du paiement',
  'Company Name': 'Nom de l\'entreprise',
  'Prepaid Request#': 'Numéro de demande Prépayé',
  'Submission#': 'Soumission #',

};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/invoicesPaymentConfirmation.js